import React, { Component } from 'react';
import { toast, ToastContainer, MDBCardText, MDBCard, MDBCardTitle, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBInputGroup, MDBContainer, MDBBadge } from 'mdbreact';
import Header from './ComponentFragments/Header';
import DataLayer from '../Utilities/DataLayer';
import Formatter from '../Utilities/Formatter';
import Colors from '../Styles/Colors';



class PFConfirm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sfOrderId: 0,
            sfInvoiceId: 0,
            receiptReference: "",
            errorMessage: "",
            errorOccurred: false,
            headerText: "",
            counter: 0,
        }
        this.formatter = new Formatter();
        this.dl = new DataLayer();
        this.getQueryParams = this.getQueryParams.bind(this);
        this.formatView = this.formatView.bind(this);
    }

    getQueryParams() {
        // initialize an empty object
        let result = {};
        // get URL query string
        let params = window.location.search;
        // remove the '?' character
        params = params.substr(1);
        let queryParamArray = params.split('&');
        // iterate over parameter array
        queryParamArray.forEach(function (queryParam) {
            // split the query parameter over '='
            let item = queryParam.split("=");
            result[item[0]] = decodeURIComponent(item[1]);
        });
        // return result object
        
        return result;
    }

    CheckTransaction = async (params) => {
        console.log('Params are: ', params)
        let sfOrderPayflexOrder = {
            PayFlexOrderId: params.orderId,
            SfOrderId: 0,
            fromClient: "true"
        }
        let response = await this.dl.Post("/Payflex/processPayflexConfirm", sfOrderPayflexOrder, false);
        console.log('the response: ', response);
        if (!response.errorOccurred) {
            if (response.data.invoiceId > 0) {
                clearInterval(this.intervalId);
                this.props.updateCartCount(0);
                this.setState({
                    sfInvoiceId: response.data.invoiceId,
                    receiptReference: 'Payflex ' + response.data.invoiceId,
                    errorOccurred: response.errorOccurred,
                    headerText: response.errorOccurred ? 'Transaction Unsuccessfull' : 'Transaction Successfull',
                    errorMessage: response.errorMessage
                })
                this.props.loaderOff()
            }
        }

        // Increment the counter
        this.setState((prevState) => {
            const newCounter = prevState.counter + 1;
            console.log('prevState: ', prevState);
            // If counter reaches 5, stop the interval
            if (newCounter >= 5) {
                clearInterval(this.intervalId);
                this.setState({
                    sfInvoiceId: -1,
                    receiptReference: '',
                    errorOccurred: true,
                    headerText: 'Alert',
                    errorMessage: 'Unable to Retrieve Transactions, Please contact your Distributor.',
                })
                this.props.loaderOff()
            }

            return { counter: newCounter };
        });
    }

    async componentDidMount() {
        var params = this.getQueryParams();
        this.intervalId = setInterval(() => this.CheckTransaction(params), 5000); // 3 seconds
    }

    componentWillUnmount() {
        clearInterval(this.intervalId);
    }

    //async componentWillMount() {
    //    var params = this.getQueryParams();
    //    let sfOrderPayflexOrder = {
    //        PayFlexOrderId: params.orderId,
    //        SfOrderId: 0,
    //        fromClient: "true"
    //    }
    //    let response = await this.dl.Post("/Payflex/processPayflexConfirm", sfOrderPayflexOrder, false);
    //    if (!response.errorOccurred) {
    //        this.props.updateCartCount(0);
    //    }
    //    this.setState({
    //        sfInvoiceId: response.data.invoiceId,
    //        receiptReference: 'Payflex ' + response.data.invoiceId,
    //        errorOccurred: response.errorOccurred,
    //        headerText: response.errorOccurred ? 'Transaction Unsuccessfull' : 'Transaction Successfull',
    //        errorMessage: response.errorMessage
    //    })
    //    this.props.loaderOff()
    //    //if (!response.errorOccurred) {
    //    //    this.props.updateCartCount(0);
    //    //}
    //}

    formatView() {
        if (!this.state.errorOccurred) {
            return (
                <div>
                    <Header headerText={this.state.headerText}
                        subHeaderText="Thank you for your order, Getting Transaction Status, Please wait..."
                        hideSearch={true}
                    />
                    <br />
                    <MDBRow>
                        <MDBCol xl="12">
                            {this.state.sfInvoiceId == -1 ? (<div><span style={{ fontSize: "14px" }}>Unable to process invoice & Receipt; your distributor must process this invoice and Receipt</span><br /></div>) : (<div><span style={{ fontSize: "14px" }}>Your Invoice Number is: <strong>{this.state.sfInvoiceId}</strong></span><br /></div>)}
                            {this.state.sfInvoiceId == -1 ? (<div></div>) : (<div><span style={{ fontSize: "14px" }}>Your Receipt Reference is: <strong>{this.state.receiptReference}</strong></span></div>)}
                        </MDBCol>
                    </MDBRow>
                </div>
            )
        } else {
            return (
                <div>
                    <Header headerText={this.state.headerText}
                        hideSearch={true}
                    />
                    <br />
                    <MDBRow>
                        <MDBCol xl="12">
                            <span style={{ fontSize: "14px" }}>Error: <strong>{this.state.errorMessage}</strong></span><br />

                        </MDBCol>
                    </MDBRow>
                </div>
            )
        }
    }

    render() {
        return (
            <div>
                {this.formatView()}
            </div>
        )
    }
}

export default PFConfirm;